import MultilevelMenuExample from './modules/multilevel.menu.example';
const menu = [
    {
        meta: {
            title: '演示',
            icon: 'uim:box',
        },
        children: [
            MultilevelMenuExample,
        ],
    },
];
export default menu;
